<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
      </div>
      <div class="">
        <el-form :model="addProductInfo" :rules="rules" ref="addProductBaseForm" label-width="120px" :show-message="false">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="prodName">
                <el-input v-model="addProductInfo.prodName" placeholder="必填，请填写商品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品分组" prop="categoryId">
                <el-select v-model="addProductInfo.categoryId" style="width:100%">
                  <el-option label="必填，请选择商品分组" value="" disabled></el-option>
                  <el-option v-for="(item, index) in addProductInfo.productCategorys" :key="index"
                    :label="item.categoryName" :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位" prop="unitName">
                <el-input v-model="addProductInfo.unitName" placeholder="必填，请填写单位"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="addProductInfo.sort" placeholder="必填，请填写排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="关键词" prop="keyword">
                <el-input v-model="addProductInfo.keyword" placeholder="必填，请填写关键词,多个关键词用;分隔">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-left">
              <el-form-item label="手机菜单">
                <el-checkbox-group v-model="addProductInfo.hktIds">
                  <el-checkbox v-for="(item, index) in addProductInfo.housekeepingTypes" :key="index"
                    :label="item.hktId">
                    {{ item.hktName }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="仓库" prop="shId">
                <el-select v-model="addProductInfo.shId" @change="_changeShopHouseAdd(addProductInfo.shId)"
                  style="width:100%">
                  <el-option label="请选择仓库" value="" disabled></el-option>
                  <el-option v-for="(item, index) in addProductInfo.shopHouses" :key="index" :label="item.shName"
                    :value="item.shId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-left">
              <el-form-item label="库存警告数量">
                <el-input-number v-model="addProductInfo.warnStock" placeholder="选填，请填写库存警告数量">
                </el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品简介" prop="prodDesc">
                <el-input type="textarea" :rows="3" v-model="addProductInfo.prodDesc" placeholder="必填，请填写商品简介"
                  maxlength="250">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品图片</span>
      </div>
      <div class="">
        <el-form :model="addProductInfo" :rules="rules" ref="addProductImageForm" label-width="120px" :show-message="false">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品封面" prop="coverPhoto">
                <upload-image-url ref="coverImageUpload" :image-count="1"
                  @notifyUploadCoverImage="handleCoverImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品轮播">
                <upload-image-url ref="carouselImageUpload" :image-count="3"
                  @notifyUploadCoverImage="handleCarouselImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品规格</span>
        <el-button type="primary" size="small" style="float:right" @click="_openAddSpecModal()">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>
      <div class="">
        <el-table :data="addProductInfo.productSpecs" border style="width:100%">
          <el-table-column prop="specName" label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specName" placeholder="请输入规格名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.stock"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.sales"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="销售价格" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.price"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.costPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="ownerPrice" label="业主价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.ownerPrice"></el-input-number>
            </template>
          </el-table-column>
          <!-- 市场价列隐藏，保留默认值以便后续激活
          <el-table-column prop="otPrice" label="市场价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.otPrice"></el-input-number>
            </template>
          </el-table-column>
          -->
          <el-table-column prop="deduction" label="抵扣金" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.deduction"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="条形码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.barCode"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="_openAddDeleteProductSpec(scope.row)">
                删除
              </el-button>
              <el-button v-if="scope.row.isDefault != 'T'" type="primary" size="mini"
                @click="_doAddDefaultProductSpec(addProductInfo, scope.row)">
                默认规格
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:15px;">
          <span>抵扣金：商家让利给用户的抵扣费用，可用于购买商品抵扣</span>
        </div>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品扩展</span>
      </div>
      <div class="">
        <el-form :model="addProductInfo" :rules="rules" ref="addProductExtForm" label-width="120px" :show-message="false">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品状态" prop="state">
                <el-select v-model="addProductInfo.state" style="width:100%">
                  <el-option label="必填，请选择状态" value="" disabled></el-option>
                  <el-option label="未上架" value="1001"></el-option>
                  <el-option label="上架" value="2002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品详情" prop="content">
                <RichTextEditor v-model="addProductInfo.content"  @input="handleContentChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top:20px;text-align:right;">
          <el-button type="warning" @click="_closeAddProduct()">
            取消
          </el-button>
          <el-button type="primary" @click="saveProductInfo()">
            <i class="el-icon-check"></i>保存
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import UploadImageUrl from '@/components/system/UploadImageUrl'
//import TinymceEditor from '@/components/TinymceEditor'
import RichTextEditor from '@/components/system/RichTextEditor.vue'

import { getDict } from '@/api/shop/shopApi'
import { getShopId,getAreaCode } from '@/api/shop/shopApi'
import { saveProduct, queryProductCategory, queryHousekeepingType, queryShopHouse } from '@/api/goods/productApi'
import { productFormRules, validateProductSpecs } from '@/utils/productFormRules'

export default {
  name: 'AddProduct',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      rules: productFormRules,
      addProductInfo: {
        shId: '',
        shName: '',
        warnStock: '',
        productId: '',
        categoryId: '',
        prodName: '',
        prodDesc: '',
        keyword: '',
        barCode: '1',
        unitName: '',
        sort: '',
        isPostage: '2',
        postage: '0.00',
        productCategorys: [],
        content: '',
        states: [],
        state: '',
        coverPhoto: '',
        carouselFigurePhoto: [],
        productSpecs: [],
        areaCode: '',
        distributionModes: [],
        hktIds: [],
        housekeepingTypes: [],
        shopHouses: []
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.initData()
  },
  methods: {
    async initData() {
      try {
        // 获取字典数据
        const { data: dictData } = await getDict('product', 'state')
        this.addProductInfo.states = dictData

        // 初始化商品数据
        this._initAddProduct()

        // 获取仓库列表
        this._listShopHouses()

        // 获取家政类型
        this._listAddHousekeepingTypes()

        // 获取商品分类
        this._listAddProductCategorys()
      } catch (error) {
        console.error('初始化数据失败:', error)
      }
    },

    handleCoverImageUpload(param) {
      if (param.length > 0) {
        this.addProductInfo.coverPhoto = param[0]
      } else {
        this.addProductInfo.coverPhoto = ''
      }
      this.$refs.addProductImageForm && this.$refs.addProductImageForm.validateField('coverPhoto')
    },

    handleCarouselImageUpload(param) {
      this.addProductInfo.carouselFigurePhoto = []
      param.forEach(p => {
        this.addProductInfo.carouselFigurePhoto.push(p)
      })
    },

    handleContentChange(content) {
      this.addProductInfo.content = content
      this.$refs.addProductExtForm && this.$refs.addProductExtForm.validateField('content')
    },

    async saveProductInfo() {
      try {
        const flag = this.addProductInfo.productSpecs.some(spec => spec.isDefault === 'T')
        if (!flag && this.addProductInfo.productSpecs.length > 0) {
          this.$message.warning('未选择默认规格')
          return
        }

        const specError = validateProductSpecs(this.addProductInfo.productSpecs)
        if (specError) {
          this.$message.warning(specError)
          return
        }

        let validBase = false
        let validImage = false
        let validExt = false
        try {
          validBase = await this.$refs.addProductBaseForm.validate()
          validImage = await this.$refs.addProductImageForm.validate()
          validExt = await this.$refs.addProductExtForm.validate()
        } catch (validateError) {
          console.error('表单校验异常:', validateError)
          this.$message.warning('商品信息还有未填写的内容，请填写完整')
          return
        }

        if (!validBase || !validImage || !validExt) {
          this.$message.warning('商品信息还有未填写的内容，请填写完整')
          return
        }

        this.addProductInfo.shopId = this.shopId
        this.addProductInfo.areaCode = getAreaCode()

        const res = await saveProduct(this.addProductInfo)
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存商品失败:', error)
        this.$message.error(error.message || error.msg || '保存商品失败')
      }
    },

    _initAddProduct() {
      // 初始化富文本编辑器
      // 这里需要根据实际使用的富文本编辑器组件进行调整
    },

    _openAddSpecModal() {
      const productSpec = {
        specCd: "0",
        stock: "0",
        sales: "0",
        price: "0.00",
        costPrice: "0.00",
        ownerPrice: "0.00",
        otPrice: "0.00",
        deduction: "0.00",
        isDefault: "F",
        barCode: ""
      }

      this.addProductInfo.productSpecs.push(productSpec)

      // 如果没有默认规格，设置第一个为默认
      if (!this.addProductInfo.productSpecs.some(spec => spec.isDefault === 'T') &&
        this.addProductInfo.productSpecs.length > 0) {
        this.addProductInfo.productSpecs[0].isDefault = "T"
      }
    },

    _openAddDeleteProductSpec(productSpec) {
      const index = this.addProductInfo.productSpecs.indexOf(productSpec)
      if (index > -1) {
        this.addProductInfo.productSpecs.splice(index, 1)
      }

      // 如果没有默认规格，设置第一个为默认
      if (!this.addProductInfo.productSpecs.some(spec => spec.isDefault === 'T') &&
        this.addProductInfo.productSpecs.length > 0) {
        this.addProductInfo.productSpecs[0].isDefault = "T"
      }
    },

    _doAddDefaultProductSpec(product, defaultProductSpec) {
      product.productSpecs.forEach(item => {
        item.isDefault = "F"
      })
      defaultProductSpec.isDefault = "T"
      this.addProductInfo.productSpecs = JSON.parse(JSON.stringify(product.productSpecs))
    },

    _changeShopHouseAdd(shopHouseId) {
      const shopHouse = this.addProductInfo.shopHouses.find(item => item.shId === shopHouseId)
      if (shopHouse) {
        this.addProductInfo.shName = shopHouse.shName
      }
    },

    async _listAddHousekeepingTypes() {
      try {
        const params = {
          page: 1,
          row: 30,
          typeCd: '2002',
          shopId: '9999',
          skipType: '3'
        }
        const res = await queryHousekeepingType(params)
        this.addProductInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取家政类型失败:', error)
      }
    },

    async _listShopHouses() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.shopId
        }
        const res = await queryShopHouse(params)
        this.addProductInfo.shopHouses = res.data
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },

    async _listAddProductCategorys() {
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: this.shopId
        }
        const res = await queryProductCategory(params)
        this.addProductInfo.productCategorys = res.data
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },

    _closeAddProduct() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #edf1f2;
  border-bottom: 1px solid #e7eaec;
  padding: 14px 15px 7px;
  min-height: 48px;
}


.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>